import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
export { default as Source } from "./components/Source/index.js";
export { default as Img } from "./components/Img/index.js";
export { default as Picture } from "./components/Picture/index.js";
export { default as useImageLazyLoadingBoundary } from "./components/useImageLazyLoadingBoundary/index.js";
export { getDefaultEnv as getMediaApiEnv } from "./utilities/createUrl/index.js";
export { ImagePreloadExtractorManager, ImagePreload, ImagePreloadRenderer, createImagePreloadExtractor } from "./components/ImagePreloadExtractor/index.js";

if (!_globalThis.lazySizes) {
  // eslint-disable-next-line global-require
  require('lazysizes'); // The following import is necessary to make sure the Picture component responds
  // to prop changes when doing lazy loading of images
  // eslint-disable-next-line global-require


  require('lazysizes/plugins/attrchange/ls.attrchange');
}